import m from './module';

/**
 * Lookup service for the recap definition editor's "Activity Types"
 * multi-select. Hits a thin server endpoint that filters to active
 * merchandising activity types for the current client. The server returns
 * an empty list when the Merchandising module is disabled, so this service
 * does not need to gate on the toggle separately.
 */
class MerchandisingActivityTypeService {
  constructor($q, APIService, LogService) {
    "ngInject";
    this.$q = $q;
    this.APIService = APIService;
    this.LogService = LogService;
    this._cache = null;
    this._pendingRequest = null;
  }

  /**
   * @returns {Promise<Array<{id: number, name: string, color: string|null, display_order: number}>>}
   */
  getAll() {
    if (this._cache) {
      return this.$q.when(this._cache);
    }
    if (this._pendingRequest) {
      return this._pendingRequest;
    }

    this._pendingRequest = this.APIService.get('/recaps/merchandising/activity_types', { force: true })
      .then(response => {
        const data = response.data || response || [];
        this._cache = Array.isArray(data) ? data : [];
        this._pendingRequest = null;
        return this._cache;
      })
      .catch(err => {
        this.LogService.error('Error fetching merchandising activity types:', err);
        this._pendingRequest = null;
        return [];
      });

    return this._pendingRequest;
  }
}

export default MerchandisingActivityTypeService;

m.service('MerchandisingActivityTypeService', MerchandisingActivityTypeService);
